import { ListingKind, ListingType } from '@ha/api/v2/types/Listing';
import { ListingEntity } from '../types';

/**
 * Essentially a copy paste of Platform's `listingType` attribute implementation.
 * We would like to make the analytics approach generic across services,
 * more at https://housinganywhere.atlassian.net/browse/GROWTH-388
 *
 * Note: we intentionally keep "bntire building" with a typo since it is too late
 * to make it changed - it will break existing funnels
 *
 * Reference:
 * https://github.com/housinganywhere/platform/blob/57815702ae7c2a0c888aac0ee59eafcb15ae612e/pkg/analytics/analytics.go#L89
 */
export function getListingType(listing: ListingEntity): string {
  if (!listing) return '';

  const {
    kind,
    type,
    facilities: { bedroom_count: bedroomCount },
  } = listing;

  if (kind === ListingKind.PrivateRoom) {
    return 'private room';
  }

  if (kind === ListingKind.SharedRoom) {
    return 'shared room';
  }

  if (type === ListingType.House) {
    return 'entire house';
  }

  if (type === ListingType.Building) {
    // please keep this type as is, we're stuck with it
    return 'bntire building';
  }

  switch (bedroomCount) {
    case '0':
      return 'studio';
    case '1':
      return '1 bedroom apartment';
    case '2':
      return '2 bedroom apartment';
    case '3':
      return '3 bedroom apartment';
    default:
      return '4 plus bedroom apartment';
  }
}
